import { render, staticRenderFns } from "./Evrak.vue?vue&type=template&id=5756d66e&lang=true&"
import script from "./Evrak.vue?vue&type=script&lang=js&"
export * from "./Evrak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports